module.exports = __webpack_public_path__ + "static/media/sf_1200_gray.ddf963647bda17aeafc5f3077eb65c46.png";